import {
  MappingLabelNode,
  ModelConceptHierarchyLabelNode,
  ModelConceptRelationshipLabelNode,
} from 'src/containers/ProjectDiagram/types/diagram';
import {
  isLink,
  isLinkLabel,
} from 'src/containers/ProjectDiagram/utils/graphObject';

// When the diagram has a selection size of 2+, we need to check that the
// selection does not consist in *only* a link and its linkLabel(s), since they
// should be treated as one entity for the purpose of multiselection behavior.
// NOTE: This is "future-proof" in case we allow links to have multiple
// linkLabels, which is allowed by GoJS.
export function hasMultiselection({ selection }: go.Diagram) {
  if (selection.size < 2) {
    return false;
  }

  // Collect the selection's links and linkLabels. If more than one link is
  // found, abort early, as that is a multiselection. If something that is
  // neither a link nor a linkLabel is found, also abort early, as that is a
  // multiselection. Otherwise, proceed.
  let selectionLink;
  const linkLabelNodesLookup = new Map<string, go.Node>();
  const { iterator } = selection;
  while (iterator.next()) {
    const { value } = iterator;
    if (isLink(value)) {
      if (selectionLink) {
        // more than one link found
        return true;
      }
      selectionLink = value;
    } else if (!isLinkLabel(value)) {
      // selection does not consist of only a link and its labels
      return true;
    } else {
      linkLabelNodesLookup.set(value.key, value);
    }
  }

  // We have at most one link in the selection, and everything else is a
  // linkLabel. If all the linkLabels are labels of the one link, this isn't
  // a true multiselection. Otherwise, it is.
  if (
    selectionLink &&
    linkLabelNodesLookup.size === selectionLink.labelNodes.count &&
    selectionLink.labelNodes.all(
      (
        // TODO: In later versions of TypeScript (4.3.5+), the typing is
        // unnecessary, as it can be inferred.
        labelNode:
          | MappingLabelNode
          | ModelConceptRelationshipLabelNode
          | ModelConceptHierarchyLabelNode
      ) => linkLabelNodesLookup.has(labelNode.key)
    )
  ) {
    return false;
  }

  return true;
}
